<!-- eslint-disable -->
<template>
  <div class="p2_dashboard_container">
    <div class="p2_dashboard_header_row">
      <h1>Your Rooms</h1>
    </div>
    <div v-if="DV_isUserOrganizationsDataReady !== true" class="p2_rooms_list_loading">
      <span>Loading...</span>
    </div>
    <div v-else-if="DV_usersInterfacesList.length > 0" class="p2_dashboard_subheader_row">
      <div class="p2_search_bar_and_title">
        <h2 class  >These are the rooms you have access to:</h2>
          <div class="p2_search_area p2_search_bar"
            >
            <i  class="p2_search_icon fa fa-search "></i>
            <input ref="search" class="p2_input"  v-model="DV_searchQuery" placeholder="Search for your rooms" type="text">
          </div>
      </div>
      <div class="p2_rooms_list_container">
        <div
          v-for="cicp in C_filteredInterfacesList"
          @click.stop="openControlPanel(cicp)"
          :key="cicp.uuid"
          class="p2_room_list_entry"
        >
          <SystemOnlineIndicator :P_cpUid="cicp.cp_uid"></SystemOnlineIndicator>
          <OrgNameLabel :P_orgUid="cicp.org_uid"></OrgNameLabel>
          >
          <ControlProcessorNameLabel :P_cpUid="cicp.cp_uid.replace('cp_', '')"></ControlProcessorNameLabel>
          <span v-if="DV_devFlag === 1">
            >
            {{cicp.cicp_uid}}
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <h3 style="margin-top: 5vh">No rooms available to show.</h3>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import OrgNameLabel from "./labels/OrgNameLabel";
import ControlProcessorNameLabel from "./labels/ControlProcessorNameLabel";
import SystemOnlineIndicator from "./labels/SystemOnlineIndicator";
import AWN from "awesome-notifications";

export default {
  components: { OrgNameLabel, ControlProcessorNameLabel, SystemOnlineIndicator },
  data() {
    return {
      DV_userOrganizationsData: {},
      DV_isUserOrganizationsDataReady: false,
      DV_dataLoadingInterval: null,
      DV_usersInterfacesList: [],
      DV_searchQuery: '',
      DV_devFlag: window.G_dev_flag,
    }
  },
  mounted() {
    const CI = this;
    CI.waitForUserInfo();
  },
  computed: {
    C_filteredInterfacesList() {
      const CI = this;
      const searchQueryLowerCase = CI.DV_searchQuery.toLowerCase();

      if (_.isEmpty(searchQueryLowerCase)) {
        return CI.DV_usersInterfacesList;
      }
      
      let filtered_rooms = [];
      for(let item of CI.DV_usersInterfacesList) {
        const nameLowerCase = item.name.toLowerCase()
        if (nameLowerCase.includes(searchQueryLowerCase)) {
          filtered_rooms.push(item);
        }
      }
      return filtered_rooms; 
    }
  },
  methods: {
    waitForUserInfo() {
      const CI = this;
      
      if (window.G_firebase_auth.IV_id_token === "" || 
          window.G_web_gui_data.IV_user_info.uid === 0 ||
          window.G_firebase_auth.IV_is_guest === true) {
        setTimeout(CI.waitForUserInfo, 1000);
        return;
      }

      window.G_web_gui_data.bi7GetUserOrganizationData();
      CI.DV_userOrganizationsData = window.G_web_gui_data.IV_user_organization_data;
      CI.DV_dataLoadingInterval = setInterval(CI.handleOrgDataLoading, 1000);
      CI.DV_orgMetadata = window.G_web_gui_data.IV_org_metadata;
      CI.DV_controlProcessorsMetadata = window.G_web_gui_data.IV_control_processors_metadata;
    },
    openControlPanel(cicp) {
      if (cicp.interface_type == "json") {
        window.open(`${window.location.origin}/device-interface?org_uid=${cicp.org_uid.replace("org_", "")}&cicp_uid=${cicp.cicp_uid.replace("cicp_", "")}`, '_blank', 'width=1320, height=836');
        return;
      }

      if (cicp.interface_type == "kbrw-streaming") {
        window.open(`${window.location.origin}/custom/pg42/device-interface?org_uid=${cicp.org_uid.replace("org_", "")}&cicp_uid=${cicp.cicp_uid.replace("cicp_", "")}`, '_blank', 'width=800, height=480');
        return;
      }

      if (cicp.interface_type == "vm-manager") {
        window.open(`${window.location.origin}/custom/pg37/vm-manager/device-interface?org_uid=${cicp.org_uid.replace("org_", "")}&cicp_uid=${cicp.cicp_uid.replace("cicp_", "")}`, '_blank', 'width=1280, height=800');
        return;
      }

      if (cicp.interface_type == "video-demo-vm-manager") {
        window.open(`${window.location.origin}/custom/pg37/video-demo-vm-manager/device-interface?org_uid=${cicp.org_uid.replace("org_", "")}&cicp_uid=${cicp.cicp_uid.replace("cicp_", "")}`, '_blank', 'width=1280, height=800');
        return;
      }

      if (cicp.interface_type == "synergy-system") {
        window.open(`${window.location.origin}/custom/pg37/zoom-control/device-interface?org_uid=${cicp.org_uid.replace("org_", "")}&cicp_uid=${cicp.cicp_uid.replace("cicp_", "")}`, '_blank', 'width=1280, height=800');
        return;
      }

      // Show alert that interface is unkown, please contact support.
      CI.$awn.warning('Interface is not defined for this system. Please contact support.');
    },
    handleOrgDataLoading() {
      const CI = this;
      if (window.G_web_gui_data.IV_user_organization_data_ready === true) {
        CI.DV_isUserOrganizationsDataReady = true;
        clearInterval(CI.DV_dataLoadingInterval);
      }
    },
    resetProblemView() {
      this.setProblemViewCommand(false);
    },
  },
  watch: {
    DV_userOrganizationsData: {
      handler() {
        const CI = this;
        if (CI.DV_userOrganizationsData && Object.keys(CI.DV_userOrganizationsData).length > 0) {
          const cicp_list = [];
          
          for (let org_uid in CI.DV_userOrganizationsData) {
            for (let cp_uid in CI.DV_userOrganizationsData[org_uid]) {
              if ("cicps" in CI.DV_userOrganizationsData[org_uid][cp_uid] === false) {
                continue;
              }

              for (let cicp_uid in CI.DV_userOrganizationsData[org_uid][cp_uid]["cicps"]) {
                let org_name = org_uid, cp_name = cp_uid;
 
                // Assume default to be JSON
                const interface_type = CI.DV_userOrganizationsData[org_uid][cp_uid]["cicps"][cicp_uid] || "json"
 
                if (org_uid in CI.DV_orgMetadata && 'name' in CI.DV_orgMetadata[org_uid]) {
                  org_name = CI.DV_orgMetadata[org_uid]['name']
                }

                if (cp_uid in CI.DV_controlProcessorsMetadata &&
                    'name' in CI.DV_controlProcessorsMetadata[cp_uid]) {
                  cp_name = CI.DV_controlProcessorsMetadata[cp_uid]['name'];
                }

                cicp_list.push({ 
                  name : `${org_name} > ${cp_name}`,
                  cicp_uid: cicp_uid,
                  cp_uid: cp_uid,
                  org_uid: org_uid,
                  uuid: String(new Date().getTime()).concat(cicp_uid),
                  interface_type: interface_type
                });
              }
            }
          }

          CI.DV_usersInterfacesList = cicp_list.sort((a, b)=>(a.name > b.name ? 1 : -1));
        }
      },
      deep: true
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue